var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-loading',{staticClass:"loading",attrs:{"color":"#9d1d22","text-color":"#9d1d22","size":"24px"}},[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }